// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { NavigationClient, type NavigationOptions } from "@azure/msal-browser";
import type { NavigateOptions } from "../router/navigation";

export type SpaNavigate = (path: string, options?: NavigateOptions) => void;

export class CustomNavigationClient extends NavigationClient {
  private readonly navigate: SpaNavigate;

  constructor(navigate: SpaNavigate) {
    super();
    this.navigate = navigate;
  }

  override async navigateInternal(url: string, options: NavigationOptions): Promise<boolean> {
    const relativePath = url.replace(window.location.origin, "") || "/";
    if (options.noHistory) {
      this.navigate(relativePath, { replace: true });
    } else {
      this.navigate(relativePath);
    }
    return false;
  }
}
